import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchBrands($sort: String, $page: Int, $limit: Int) {
    Brands(sort: $sort, page: $page, limit: $limit) {
      totalDocs
      page
      totalPages
      docs {
        id
        name
        logo {
          url
        }
        slug
      }
    }
  }
`

export enum BrandsSort {
  NameAsc = 'name',
  NameDesc = '-name',
}

export interface BrandsQueryInput {
  page?: number
  limit?: number
  sort?: BrandsSort
}

export interface BrandsQueryOutput {
  Brands: {
    totalDocs: number
    page: number
    totalPages: number
    docs: {
      id: string
      name: string
      logo?: {
        url: string
      }
      slug: string
    }[]
  }
}

const defaultVariables: BrandsQueryInput = {
  page: 1,
  limit: 1000,
  sort: BrandsSort.NameAsc,
}

export const useBrandsQuery = (options?: QueryHookOptions<BrandsQueryOutput, BrandsQueryInput>) =>
  usePersistedCacheQuery(query, {
    variables: defaultVariables,
    ...options,
  })


export const brandsQuery = {
  query,
  defaultVariables,
}
